module.exports = __webpack_public_path__ + "img/img_wx.343181f7.png";